import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'integration-audit',
  templateUrl: './integrationAudit.component.html',
  styleUrls: ['./integrationAudit.component.less'],
  providers: [FrameworkUtilityComponent]
})
export class IntegrationAuditComponent implements OnInit {

  applicationId: any;
  currentRoutePath: string;

  constructor(private router: Router, private util: UtilService, private activatedRoute: ActivatedRoute) {

    this.activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });


  }
  ngOnInit(): void {

  }

  search() {
    let rJson;
    if (!this.applicationId) {
      return;
    }
    this.util.getAuditHistory(this.applicationId).subscribe((event) => {
      // alert(event)
      rJson = event;
      localStorage.setItem('applicationId', this.applicationId);
      localStorage.setItem('rJson', JSON.stringify(rJson));
      this.router.navigate(['../view-audit-details'], { relativeTo: this.activatedRoute, queryParamsHandling: 'preserve' });
    });



  }

  clear() {
    this.applicationId = null;
  }

}